/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMotorbike = createReactComponent("motorbike", "IconMotorbike", [
  ["path", { d: "M5 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M19 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4", key: "svg-2" }],
  ["path", { d: "M13 6h2l1.5 3l2 4", key: "svg-3" }]
]);

export { IconMotorbike as default };
//# sourceMappingURL=IconMotorbike.js.map
